import { render, staticRenderFns } from "./AddNewPrepModal.vue?vue&type=template&id=480b071f&scoped=true"
import script from "./AddNewPrepModal.vue?vue&type=script&lang=js"
export * from "./AddNewPrepModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480b071f",
  null
  
)

export default component.exports